import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import axiosInstance from './axiosConfig';

// Menü kategorileri API fonksiyonları
export const getAllCategories = async () => {
  try {
    const response = await axiosInstance.get('/admin/menu/categories');
    return response.data;
  } catch (error) {
    console.error('getAllCategories error:', error);
    return { success: false, data: [], count: 0, message: error.message || 'Kategoriler yüklenirken bir hata oluştu' };
  }
};

export const getCategoryById = async (id) => {
  try {
    const response = await axiosInstance.get(`/admin/menu/categories/${id}`);
    return response.data;
  } catch (error) {
    console.error('getCategoryById error:', error);
    return { success: false, data: null, message: error.message || 'Kategori detayları yüklenirken bir hata oluştu' };
  }
};

// Kategori ID'sine göre menü öğelerini getir
export const getItemsByCategory = async (categoryId) => {
  try {
    const response = await axiosInstance.get(`/admin/menu/categories/${categoryId}/items`);
    return response.data;
  } catch (error) {
    console.error('getItemsByCategory error:', error);
    return { success: false, data: [], message: error.message || 'Kategori ürünleri yüklenirken bir hata oluştu' };
  }
};

export const createCategory = async (categoryData) => {
  try {
    const response = await axiosInstance.post('/admin/menu/categories', categoryData);
    return response.data;
  } catch (error) {
    console.error('createCategory error:', error);
    return { success: false, message: error.message || 'Kategori oluşturulurken bir hata oluştu' };
  }
};

export const updateCategory = async (id, categoryData) => {
  try {
    const response = await axiosInstance.put(`/admin/menu/categories/${id}`, categoryData);
    return response.data;
  } catch (error) {
    console.error('updateCategory error:', error);
    return { success: false, message: error.message || 'Kategori güncellenirken bir hata oluştu' };
  }
};

export const deleteCategory = async (id) => {
  try {
    //console.log(`API call: deleteCategory(${id})`);
    const response = await axiosInstance.delete(`/admin/menu/categories/${id}`);
    //console.log('Delete category API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('deleteCategory error:', error);
    if (error.response) {
      console.error('Error response data:', error.response.data);
      console.error('Error response status:', error.response.status);
      return { 
        success: false, 
        message: error.response.data?.message || error.message || 'Kategori silinirken bir hata oluştu',
        statusCode: error.response.status
      };
    }
    return { success: false, message: error.message || 'Kategori silinirken bir hata oluştu' };
  }
};

// Menü öğeleri API fonksiyonları
export const getAllMenuItems = async () => {
  try {
    const response = await axiosInstance.get('/admin/menu/items');
    return response.data;
  } catch (error) {
    console.error('getAllMenuItems error:', error);
    return { success: false, data: [], count: 0, message: error.message || 'Menü öğeleri yüklenirken bir hata oluştu' };
  }
};

export const createMenuItem = async (menuItemData) => {
  try {
    //console.log('Sending menu item data:', JSON.stringify(menuItemData)); // Veriyi logla
    const response = await axiosInstance.post('/admin/menu/items', menuItemData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: error.message };
  }
};

export const updateMenuItem = async (menuItemId, menuItemData) => {
  try {
    //console.log('Updating menu item data:', JSON.stringify(menuItemData)); // Veriyi logla
    const response = await axiosInstance.put(`/admin/menu/items/${menuItemId}`, menuItemData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: error.message };
  }
};

export const deleteMenuItem = async (menuItemId) => {
  try {
    const response = await axiosInstance.delete(`/admin/menu/items/${menuItemId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: error.message };
  }
};

// Dashboard istatistikleri
export const getDashboardStats = async () => {
  try {
    const response = await axiosInstance.get('/admin/dashboard/stats');
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: error.message };
  }
};

// Kullanıcı yönetimi API fonksiyonları
export const getAllUsers = async () => {
  try {
    const response = await axiosInstance.get('/admin/users');
    return response.data;
  } catch (error) {
    console.error('getAllUsers error:', error);
    return { success: false, data: [], count: 0, message: error.message || 'Kullanıcılar yüklenirken bir hata oluştu' };
  }
};

export const getUserById = async (id) => {
  try {
    //console.log(`API call: getUserById(${id})`);
    const response = await axiosInstance.get(`/admin/users/${id}`);
    //console.log('Get user API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('getUserById error:', error);
    if (error.response) {
      console.error('Error response data:', error.response.data);
      console.error('Error response status:', error.response.status);
      return error.response.data || { 
        success: false, 
        message: 'Kullanıcı detayı alınırken bir hata oluştu'
      };
    }
    return { 
      success: false, 
      message: error.message || 'Kullanıcı detayı alınırken bir hata oluştu' 
    };
  }
};

export const createUser = async (userData) => {
  try {
    const response = await axiosInstance.post('/admin/users', userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: error.message };
  }
};

export const updateUser = async (id, userData) => {
  try {
    //console.log(`API call: updateUser(${id})`, userData);
    const response = await axiosInstance.put(`/admin/users/${id}`, userData);
    //console.log('Update user API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('updateUser error:', error);
    if (error.response) {
      console.error('Error response data:', error.response.data);
      console.error('Error response status:', error.response.status);
      return error.response.data || { 
        success: false, 
        message: 'Kullanıcı güncellenirken bir hata oluştu'
      };
    }
    return { 
      success: false, 
      message: error.message || 'Kullanıcı güncellenirken bir hata oluştu' 
    };
  }
};

// Admin kullanıcının bir kullanıcının şifresini sıfırlaması için özel endpoint
export const resetUserPassword = async (userId, newPassword) => {
  try {
    //console.log(`API call: resetUserPassword(${userId})`);
    // Yeni şifre sıfırlama endpoint'i
    const response = await axiosInstance.post(`/admin/users/${userId}/reset-password`, { 
      password: newPassword 
    });
    //console.log('Reset password API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('resetUserPassword error:', error);
    if (error.response) {
      console.error('Error response data:', error.response.data);
      console.error('Error response status:', error.response.status);
      return error.response.data || { 
        success: false, 
        message: 'Şifre sıfırlanırken bir hata oluştu'
      };
    }
    return { 
      success: false, 
      message: error.message || 'Şifre sıfırlanırken bir hata oluştu' 
    };
  }
};

export const toggleUserStatus = async (id, isActive) => {
  try {
    //console.log(`API call: toggleUserStatus(${id}, ${isActive})`);
    
    // API endpointi doğru mu kontrol edelim
    const response = await axiosInstance.patch(`/admin/users/${id}/status`, { 
      is_active: isActive
    });
    
    //console.log('Toggle user status API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('toggleUserStatus error:', error);
    if (error.response) {
      console.error('Error response data:', error.response.data);
      console.error('Error response status:', error.response.status);
      console.error('Error response headers:', error.response.headers);
      console.error('Error request config:', error.config);
      
      return error.response.data || { 
        success: false, 
        message: 'Kullanıcı durumu değiştirilirken bir hata oluştu'
      };
    }
    return { 
      success: false, 
      message: error.message || 'Kullanıcı durumu değiştirilirken bir hata oluştu' 
    };
  }
};

// Çocuk yönetimi API fonksiyonları
export const getAllChildren = async () => {
  try {
    const response = await axiosInstance.get('/admin/children');
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: error.message };
  }
};

export const getChildById = async (id) => {
  try {
    const response = await axiosInstance.get(`/admin/children/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: error.message };
  }
};

export const updateChild = async (id, childData) => {
  try {
    const response = await axiosInstance.put(`/admin/children/${id}`, childData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: error.message };
  }
};

export const deleteChild = async (id) => {
  try {
    //console.log(`API call: deleteChild(${id})`);
    const response = await axiosInstance.delete(`/admin/children/${id}`);
    //console.log('Delete child API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('deleteChild error:', error);
    if (error.response) {
      console.error('Error response data:', error.response.data);
      console.error('Error response status:', error.response.status);
      return { 
        success: false, 
        message: error.response.data?.message || error.message || 'Çocuk silinirken bir hata oluştu',
        statusCode: error.response.status
      };
    }
    return { success: false, message: error.message || 'Çocuk silinirken bir hata oluştu' };
  }
};

// Park ziyaretleri API fonksiyonları (Activity olarak yönetilecek)
export const getActiveVisits = async () => {
  try {
    const response = await axiosInstance.get('/admin/visits/active');
    return response.data;
  } catch (error) {
    console.error('getActiveVisits error:', error);
    return { success: false, data: [], count: 0, message: error.message || 'Aktif ziyaretler yüklenirken bir hata oluştu' };
  }
};

export const getPendingVisits = async () => {
  try {
    const response = await axiosInstance.get('/admin/visits/pending');
    return response.data;
  } catch (error) {
    console.error('getPendingVisits error:', error);
    return { success: false, data: [], count: 0, message: error.message || 'Onay bekleyen ziyaretler yüklenirken bir hata oluştu' };
  }
};

export const approveVisit = async (visitId) => {
  try {
    const response = await axiosInstance.post(`/admin/visits/approve/${visitId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: error.message };
  }
};

export const getVisitHistory = async (filters = {}) => {
  try {
    // Query parametreleri için URL oluştur
    let url = '/admin/visits/history';
    const queryParams = [];
    
    if (filters.childId) {
      queryParams.push(`childId=${filters.childId}`);
    }
    
    if (filters.date) {
      queryParams.push(`date=${filters.date}`);
    }
    
    // Status filtresi eklendi
    if (filters.status) {
      queryParams.push(`status=${filters.status}`);
    }
    
    // Query parametrelerini URL'e ekle
    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&');
    }
    
    //console.log("getVisitHistory - API çağrısı yapılıyor:", url);
    //console.log("getVisitHistory - Filtreler:", JSON.stringify(filters, null, 2));
    
    // Artık axiosInstance otomatik olarak token ekleyecek
    const response = await axiosInstance.get(url);
    //console.log("getVisitHistory - API yanıtı:", response.status, response.statusText);
    //console.log("getVisitHistory - API yanıt içeriği:", JSON.stringify(response.data, null, 2));
    
    return response.data;
  } catch (error) {
    console.error('getVisitHistory error:', error);
    console.error('getVisitHistory error details:', error.response?.data || 'Response detayı yok');
    console.error('getVisitHistory error status:', error.response?.status);
    console.error('getVisitHistory error URL:', error.config?.url);
    console.error('getVisitHistory error method:', error.config?.method);
    
    // Daha fazla hata durumu bilgisi ekleyelim
    const errorMessage = error.response?.data?.message || error.message || 'Ziyaret geçmişi yüklenirken bir hata oluştu';
    const statusCode = error.response?.status || 500;
    
    return {
      success: false,
      data: [],
      count: 0,
      message: `${errorMessage} (HTTP ${statusCode})`,
      error: error.message
    };
  }
};

export const startVisit = async (childId, notes) => {
  try {
    const response = await axiosInstance.post(`/admin/visits/start/${childId}`, { notes });
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: error.message };
  }
};

export const endVisit = async (visitId, notes) => {
  try {
    const response = await axiosInstance.post(`/admin/visits/end/${visitId}`, { notes });
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: error.message };
  }
};

// Ziyareti iptal et (Admin için)
export const cancelVisit = async (visitId) => {
  try {
    const response = await axiosInstance.post(`/activities/cancel/${visitId}`);
    return response.data;
  } catch (error) {
    console.error('Ziyaret iptal hatası:', error);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Ziyaret iptal edilirken bir hata oluştu'
    };
  }
};
